// Extract YouTube video ID from various URL formats
export const getYouTubeVideoId = (url: string): string | null => {
  if (!url) return null;

  // Handle youtu.be short URLs with query parameters
  const shortUrlMatch = url.match(/youtu\.be\/([a-zA-Z0-9_-]{11})/);
  if (shortUrlMatch) return shortUrlMatch[1];

  // Handle youtube.com URLs
  const longUrlMatch = url.match(/[?&]v=([a-zA-Z0-9_-]{11})/);
  if (longUrlMatch) return longUrlMatch[1];

  // Handle embed URLs
  const embedMatch = url.match(/\/embed\/([a-zA-Z0-9_-]{11})/);
  if (embedMatch) return embedMatch[1];

  return null;
};
